import React from 'react';

import Cover from 'components/Cover';

const Card = ({ name, description, category, banner, children }) => {
  return (
    <article className="card">
      <Cover src={banner} />
      <div className="card__content">
        <span className="card__category">{category}</span>
        <h2 className="card__title">{name}</h2>
        <p className="card__subtitle">{description}</p>
      </div>
      <footer className="card__extras">{children}</footer>
    </article>
  );
};

export default Card;
